import React from "react";
import { inr } from "../lib/api";

const COLS = [["invoices", "Invoices"], ["sales", "Sales"], ["money_in", "Money in"], ["money_out", "Money out"], ["cash_balance", "Cash balance"], ["bank_balance", "Bank balance"]];

export const BranchSummary = ({ data }) => (
  <div className="overflow-auto border border-border rounded-lg bg-card">
    <table data-testid="branch-summary-table" className="w-full text-sm">
      <thead className="bg-muted text-xs uppercase text-muted-foreground">
        <tr><th className="px-3 py-2 text-left">Branch</th>{COLS.map(([k, l]) => <th key={k} className="px-3 py-2 text-right whitespace-nowrap">{l}</th>)}</tr>
      </thead>
      <tbody>
        {data.rows.map((r) => (
          <tr key={r.company_id} data-testid={`branch-sum-${r.company_id}`} className="border-t border-border">
            <td className="px-3 py-2 font-medium">{r.branch}</td>
            {COLS.map(([k]) => <td key={k} className="px-3 py-2 text-right num whitespace-nowrap">{k === "invoices" ? r[k] : inr(r[k])}</td>)}
          </tr>
        ))}
      </tbody>
      <tfoot className="bg-muted font-bold">
        <tr data-testid="branch-sum-total"><td className="px-3 py-2">All branches</td>{COLS.map(([k]) => <td key={k} className="px-3 py-2 text-right num whitespace-nowrap">{k === "invoices" ? data.totals[k] : inr(data.totals[k])}</td>)}</tr>
      </tfoot>
    </table>
    <p className="text-xs text-muted-foreground px-3 py-2">Money in/out for the selected dates; cash and bank balances as on the end date. Only branches you have access to are shown.</p>
  </div>
);
